import useSWR from "swr";
import { defaultSWROption } from "@/services/api/api.service";
import { AttributeService } from "@/services/attribute/attribute.service";

export const useAttributes = (workspaceId: string, detail: boolean = false) => {
  const key = ["attributes", workspaceId, detail];

  const fetcher = ([_, workspaceId, detail]: [string, string, boolean]) =>
    AttributeService.getAttributes(workspaceId, detail);

  const { data: attributes, error, isLoading, mutate } = useSWR(
    key,
    fetcher,
    defaultSWROption,
  );

  return {
    attributes,
    error,
    isLoading,
    mutate,
  };
};
